export const systems = [
  {
    id: "ducted",
    label: "Whole-home comfort",
    title: "Rinnai Ducted Air Conditioning",
    description:
      "One carefully designed system for quiet, discreet heating and cooling throughout your home.",
    bestFor: "Larger homes, new builds, renovations and replacing existing ducted systems",
    benefits: ["Room zoning", "Discreet ceiling outlets", "Inverter technology", "Smart control options"],
    image: "https://cdn.magicpatterns.com/patterns/generated-images/c77a8478-080e-4c43-adbf-0892a21ee5d8.jpg",
    primary: true,
  },
  {
    id: "split",
    label: "Individual spaces",
    title: "Rinnai Split Systems",
    description:
      "Efficient reverse-cycle comfort for bedrooms, living areas, home offices and apartments.",
    bestFor: "One room or a specific living zone",
    benefits: ["Heating and cooling", "Quiet operation", "Efficient inverter technology", "Wi-Fi on applicable models"],
    image: "https://cdn.magicpatterns.com/patterns/generated-images/5c1c3737-939c-4098-b1a8-18a6c6c7a9b8.jpg",
    primary: false,
  },
  {
    id: "multi",
    label: "Flexible multi-room comfort",
    title: "Multiple Rooms. One Outdoor Unit.",
    description:
      "Connect multiple indoor units to one outdoor system for independent comfort without crowding your exterior.",
    bestFor: "A few rooms with different comfort needs",
    benefits: ["Independent room control", "Multiple indoor-unit options", "Cleaner exterior", "Wi-Fi capability on applicable systems"],
    image: "https://cdn.magicpatterns.com/patterns/generated-images/6d0072cf-1c17-4313-a0df-38bc8cdcd47e.jpg",
    primary: false,
  },
];

export const reasons = [
  { title: "Built for Australian conditions", text: "Rinnai systems are developed for the demands of Australian homes and weather." },
  { title: "Efficient inverter technology", text: "Output adjusts as conditions change to maintain comfort without unnecessary energy use." },
  { title: "Quiet home comfort", text: "Selected systems are engineered to minimise disruption in living and sleeping spaces." },
  { title: "Heating and cooling", text: "Reverse-cycle options help keep your home comfortable through Perth summers and winters." },
  { title: "Smart control", text: "Wi-Fi, schedules and voice compatibility are available on applicable products and configurations." },
  { title: "Flexible zoning", text: "Condition the areas you use, when configured with compatible ducted zoning controls." },
];

export const sizingFactors = [
  "Floor area",
  "Ceiling height",
  "Glazing",
  "Insulation",
  "Orientation",
  "Room usage",
  "Perth climate",
  "Zoning needs",
];

export const replacementSigns = [
  "Struggles on hot days",
  "Uneven room temperatures",
  "Noisy operation",
  "Repeated repair costs",
  "Limited controls or zoning",
  "Rising running costs",
];

export const serviceReasons = [
  { title: "30+ years of Perth experience", text: "Long-standing local air-conditioning knowledge applied to Perth homes and climate." },
  { title: "ARC Tick licensed installation", text: "Professional installation by appropriately licensed air-conditioning specialists." },
  { title: "Correct system selection", text: "Clear advice on which Rinnai format, capacity, zones and controls suit your home." },
  { title: "Supply, installation and removal", text: "One local team responsible for the new system and removal requirements agreed in your quote." },
];
